import React, { useEffect, useState } from 'react';
import '../../assets/css/snthsHstry.css'
import { getDateFormat } from '../../utils/comm';
import Input from '../../components/Input';
import DataGridMUI from '../../components/DataGridMUI';
import axiosInstance from '../../api/axiosInstance';

const SnthsHstry = () => {
  const [searchParam, setSearchParam] = useState({
    'START_DATE': getDateFormat('yyyy-mm-dd', 0, 0, -7)
    , 'END_DATE' : getDateFormat()
  }); // 조회조건 
  const [gridItemList, setGridItemList] = useState([]); // 그리드 아이템 리스트
  const grid_Columns = [
    { id: 'index', name: '순번', type: 'index'},
    { id: 'DATA_CHG_TYPE_NM', name: '작업유형', textAlign: 'center', readOnly: 'true'},
    { id: 'ARTCL_NM', name: '항목명', textAlign: 'center', readOnly: 'true'},
    { id: 'ATRB_NM', name: '속성명', textAlign: 'center', readOnly: 'true'},
    { id: 'CHG_SE', name: '변경 구분', textAlign: 'center', readOnly: 'true'},
    { id: 'CHG_BFR_CN', name: '변경 전 내용', textAlign: 'center', readOnly: 'true'},
    { id: 'CHG_AFTR_CN', name: '변경 후 내용', textAlign: 'center', readOnly: 'true'},
    { id: 'JOB_ID', name: '작업자', textAlign: 'center', readOnly: 'true'},
    { id: 'JOB_DT', name: '작업일시', width: '200', textAlign: 'center', readOnly: 'true'},
];

  useEffect(() => {
    S_01();
  }, []); // 의존성 배열이 비어 있음 → mount 시 1회만 실행

  // 조회
  const S_01 = async () => {
    try {
        const SnthsHstryResDtl = await axiosInstance.get('/SnthsHstry/findAll', {
            params: {...searchParam}
        });

        // 아이템 상태값 추가 
        SnthsHstryResDtl.data.forEach(element => {
            element.status = 'load';
        });
        
        setGridItemList(SnthsHstryResDtl.data);
    } catch (error) {
        console.error('Error ComponentMaster - S_01', error)
    }
};

  return (
    <div className="history-page">
      <div className="section-title">
        종합 이력 조회
      </div>

      <div className="search-bar-wrapper">
        <div className="search-bar">
          <label htmlFor="start-date">작업 기간</label>
          <Input
            type="date"
            id="START_DATE"
            bind={searchParam}
            setBind={setSearchParam}
            width='120'
          ></Input>
          <span>~</span>
          <Input
            type="date"
            id="END_DATE"
            bind={searchParam}
            setBind={setSearchParam}
            width='120'
          ></Input>
        </div>
        <button className="search-btn-standalone" onClick={S_01}>
          조회
        </button>
      </div>

      <DataGridMUI
          columns={grid_Columns}
          data={gridItemList}
          setBind={setGridItemList}
          getRowClassName={(params) => {
            const type = params.row.DATA_CHG_TYPE_NM;
            if (type === '신규') return 'row-new';
            if (type === '수정') return 'row-update';
            return '';
          }}
      ></DataGridMUI>
    </div>
  );
};

export default SnthsHstry;
